// Validators return a locale string id on failure, undefined when valid.
// Optional fields skip validation when empty; required fields do not.

type Validator = (value: string) => string | undefined;

export const required: Validator = (value) =>
  value.trim() ? undefined : 'STR_VALIDATION_REQUIRED';

export const optionalOr =
  (validator: Validator): Validator =>
  (value) =>
    value.trim() ? validator(value) : undefined;

export const validEmail: Validator = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim())
    ? undefined
    : 'STR_VALIDATION_EMAIL';

export const validPhone: Validator = (value) => {
  const digits = value.replace(/\D/g, '');
  return digits.length === 10 || (digits.length === 11 && digits[0] === '1')
    ? undefined
    : 'STR_VALIDATION_PHONE';
};

export const validZip: Validator = (value) =>
  /^\d{5}(-\d{4})?$/.test(value.trim()) ? undefined : 'STR_VALIDATION_ZIP';

export const validDate: Validator = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value.trim())) return 'STR_VALIDATION_DATE';
  return Number.isNaN(new Date(value.trim()).getTime())
    ? 'STR_VALIDATION_DATE'
    : undefined;
};

export const compose =
  (...validators: Validator[]): Validator =>
  (value) =>
    validators.reduce<string | undefined>(
      (error, validator) => error ?? validator(value),
      undefined,
    );
